<!--  -->
<template>
  <div class="add_box">
    <div class="search_box">
      <div class="uawewr">
        <el-input
          v-model="objr.task_id"
          style="width:200px;margin-right:10px"
          placeholder="请输入批次编号"
        />
        <!-- <div class="uawewr">
          <div>下载状态：</div>
          <el-select
            v-model="objr.download_status"
            style="margin-right:10px;width:200px"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="uawewr">
          <div>转码状态：</div>
          <el-select
            v-model="objr.transcode_status"
            style="margin-right:10px;width:200px"
            placeholder="请选择"
          >
            <el-option
              v-for="item in optionsone"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="uawewr">
          <div>变色龙上报状态：</div>
          <el-select
            v-model="objr.chameleon_status"
            style="margin-right:10px;width:200px"
            placeholder="请选择"
          >
            <el-option
              v-for="item in optionstwo"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="uawewr">
          <div>是否通知变色龙：</div>
          <el-select
            v-model="objr.chameleon_notice"
            style="margin-right:10px;width:200px"
            placeholder="请选择"
          >
            <el-option
              v-for="item in optionsthree"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="uawewr">
          <div>adx推送状态：</div>
          <el-select
            v-model="objr.push_adx_download"
            style="margin-right:10px;width:200px"
            placeholder="请选择"
          >
            <el-option
              v-for="item in optionsfour"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div> -->

        <el-button
          type="primary"
          style="margin-left:10px"
          icon="el-icon-search"
          @click="sraw"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh"
          @click="awered"
        >重置</el-button>
      </div>
      <div>
        <!-- <el-button
          type="success"
          icon="el-icon-plus"
          @click="addbit"
        >新增</el-button> -->
      </div>
    </div>

    <!-- <el-button type="primary" @click="awered">重置</el-button> -->
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%;margin-top:20px"
    >
      <el-table-column
        prop="task_id"
        label="批次编号"
        align="center"
        width="400"
      >
        <template scope="scope">
          <div v-if="scope.row.task_id">{{ scope.row.task_id }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="material_nos"
        label="素材编号组"
        width="300"
        align="center"
      >
        <template #default="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.material_nos.join(', ')"
            placement="top"
          >
            <div class="multi-line-ellipsisweq">
              <div
                v-for="(item, index) in scope.row.material_nos"
                :key="index"
              >
                {{ item }}
              </div>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="chameleon_user_name"
        label="变色龙账号ID"
        width="200"
        align="center"
      />
      <el-table-column
        prop="adx_user_name"
        label="ADX账号名称"
        width="200"
        align="center"
      />
      <el-table-column
        prop="leader_name"
        label="管理员"
        width="150"
        align="center"
      />
      <el-table-column
        prop="order_id"
        label="订单ID"
        width="150"
        align="center"
      />
      <el-table-column
        prop="chameleon_status_text"
        label="上报状态"
        width="150"
        align="center"
      >
        <template scope="scope">
          <div class="status-wrapper">
            <span :class="['status-dot', getDotClass(scope.row.chameleon_status)]" />
            <span>{{ scope.row.chameleon_status_text }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="download_status_text"
        label="下载状态"
        width="150"
        align="center"
      >
        <template scope="scope">
          <div class="status-wrapper">
            <span :class="['status-dot', getDotClass(scope.row.download_status)]" />
            <span>{{ scope.row.download_status_text }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="transcode_status_text"
        label="转码状态"
        width="150"
        align="center"
      >
        <template scope="scope">
          <div class="status-wrapper">
            <span :class="['status-dot', getDotClass(scope.row.transcode_status)]" />
            <span>{{ scope.row.transcode_status_text }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="push_adx_download_text"
        label="推送状态"
        width="150"
        align="center"
      >
        <template scope="scope">
          <el-tag :type="scope.row.push_adx_download ==1? 'info':'success'"> {{ scope.row.push_adx_download_text }} </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="chameleon_notice_text"
        label="通知状态"
        width="150"
        align="center"
      >
        <template scope="scope">
          <el-tag :type="scope.row.chameleon_notice ==1? 'info':'success'"> {{ scope.row.chameleon_notice_text }} </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at"
        label="创建时间"
        align="center"
      /> -->
      <el-table-column
        align="center"
        prop="work_status"
        label="操作"
      >
        <!-- slot-scope="scope" -->
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="xiangqing(scope.row.task_id)"
          >详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      ref="paginationbox"
      :total="newtotalr"
      :page-sizes="[10]"
      @size-change="fetchPageSizer($event)"
      @current-change="fetchCurrentPager"
    />

  </div>
</template>
<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { kafkalist } from '@/api/taobaoLink.js'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      dialogVisible: false,
      objr: {
        page: 1,
        page_size: 10,
        // download_status: 0,
        // transcode_status: 0,
        // chameleon_status: 0,
        // chameleon_notice: '',
        // push_adx_download: '',
        task_id: ''
      },
      adtype: null,
      newtotalr: null,
      tableData: [],
      loading: false,
      options: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '成功'
        },
        {
          value: 2,
          label: '失败'
        }
      ],
      optionsone: [
        {
          value: 0,
          label: '全部转码'
        },
        {
          value: 1,
          label: '转码成功'
        },
        {
          value: 2,
          label: '转码失败'
        }
      ],
      optionstwo: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '成功'
        },
        {
          value: 2,
          label: '失败'
        }
      ],
      optionsthree: [
        {
          value: 1,
          label: '未通知'
        },
        {
          value: 2,
          label: '已经通知'
        },
        {
          value: 3,
          label: '通知失败'
        }
      ],
      optionsfour: [
        {
          value: 1,
          label: '未推送'
        },
        {
          value: 2,
          label: '已经推送'
        }
      ]
    }
  },
  created() {
    this.menuList()
  },
  mounted() {},
  methods: {
    async menuList() {
      // 获取列表
      this.loading = true
      const data = await kafkalist(this.objr)
      console.log('data', data)
      this.loading = false
      this.tableData = data.data.list
      this.newtotalr = data.data.count
    },
    sraw() {
      this.objr.page = 1
      // this.objr.pageSize = 10
      this.menuList()
    },
    awered() {
      this.objr.page = 1
      // this.objr.download_status = 0
      // this.objr.transcode_status = 0
      // this.objr.chameleon_status = 0
      // this.objr.chameleon_notice = ''
      // this.objr.push_adx_download = ''
      this.objr.task_id = ''
      this.menuList()
    },
    addbit() {
      this.dialogVisible = true
      this.adtype = 1
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.readingcreateview.send(1)
      }, 100)
    },
    edit(item) {
      this.dialogVisible = true
      this.adtype = 2
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.readingcreateview.send(2, item)
      }, 100)
    },
    // 删除
    // async deleteItem(row) {
    //   this.$confirm('是否确定删除该条信息吗', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     closeOnClickModal: false,
    //     type: 'info'
    //   }).then(async() => {
    //     await createadconfigdel({ id: row.id })
    //     this.menuList()
    //     this.$message({
    //       message: '删除成功',
    //       type: 'success'
    //     })
    //   })
    // },
    // 分页
    fetchPageSizer(e) {
      this.objr.pageSize = e
      this.menuList()
    },
    fetchCurrentPager(e) {
      this.objr.page = e
      this.menuList()
    },
    updatawe() {
      this.dialogVisible = false
      this.menuList()
    },
    getDotClass(status) {
      switch (status) {
        case 0:
          return 'dot-orange' // 橙色：处理中
        case 1:
          return 'dot-green' // 成功
        case 2:
          return 'dot-red' // 失败
        default:
          return 'dot-gray' // 未知状态
      }
    },
    xiangqing(task_id) {
      this.$router.push({ path: '/adxTaskDetails/index', query: { task_id: task_id }})
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.add_box {
  padding: 20px;
}
.search_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.multi-line-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 最多两行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4em;
  max-height: 2.8em; /* 1.4em * 2 */
  word-break: break-all;
}
.status-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}
.multi-line-ellipsisweq {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 限制显示两行 */
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5em;
  max-height: 3em; /* 2行 * 1.5em */
  word-break: break-all;
  cursor: pointer;
}
.uawewr {
  display: flex;
  align-items: center;
}
.status-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #666;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 6px;
}

.dot-green {
  background-color: #52c41a;
}
.dot-orange {
  background-color: #faad14;
}
.dot-red {
  background-color: #ff4d4f;
}
.dot-gray {
  background-color: #d9d9d9;
}
</style>
